module.exports = __webpack_public_path__ + "img/hr-dry-hairy-tree-08.bbc6f4d2.png";